const track = (event, properties, options, fn) => {
  typeof window !== 'undefined' &&
    window.analytics &&
    window.analytics.track &&
    window.analytics.track(event, properties, options, fn);
  typeof window !== 'undefined' &&
    window.htevents &&
    window.htevents.track &&
    window.htevents.track(event, properties, options, fn);
};
export const identify = (userId, traits, options, callback) => {
  typeof window !== 'undefined' &&
    window.analytics &&
    window.analytics.identify &&
    window.analytics.identify(userId, traits, options, callback);
  typeof window !== 'undefined' &&
    window.htevents &&
    window.htevents.identify &&
    window.htevents.identify(userId, traits, options, callback);
};
export const page = (...args) => {
  typeof window !== 'undefined' && window.analytics && window.analytics.page && window.analytics.page(...args);
  typeof window !== 'undefined' && window.htevents && window.htevents.page && window.htevents.page(...args);
};
export default track;
